module.exports = __webpack_public_path__ + "media/images/cancel-c31d8d0db077d6acae8fb64ccb5fddd6.svg";